<div class="p-d-flex p-jc-end">
  <label class="switch-label">Zoom/Pan</label>
  <p-inputSwitch [ngModel]="chartOptions.plugins.zoom.zoom.enabled"
                 (onChange)="changeZoomPan()" ></p-inputSwitch>
</div>
<p-chart type="line" [data]="cmpData" [options]="chartOptions" #chart
         [height]="chartHeight" [width]="chartWidth"></p-chart>
<!-- Loading Spinner -->
<img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">
